import { useEffect, useState } from 'react'
import { Card, Grid, TextField, Container, FormControlLabel, Checkbox, Typography } from '@mui/material'
import { makeStyles } from '@material-ui/core'
import MessageError from '../../../messages/messageError'
import api from '../../../services/api'
import { useSelector } from 'react-redux'
import MessageSuccess from '../../../messages/messageSuccess'
import HeaderGestorConfigs from '../../../utils/headerGestorConfigs'
import ButtonLeft from '../../../utils/buttonLeft'
import Loading from '../../../load/loading'


const useStyles = makeStyles((theme) => ({
    root: {
        alignItems: 'end',
    },

    gridItem: {
        padding: 5,
        // background: 'red'
    },
}))

export default function CreateDepartamento() {
    const classes = useStyles()
    const [departamento, setDepartamento] = useState('')
    const [departamentos, setDepartamentos] = useState('')
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setErrorMessage] = useState('')
    const [load, setLoad] = useState(false)
    const user = useSelector(state => state.account.user);

    useEffect(() => {
        api.get('/depatamentos')
            .then(res => {
                // console.log(res)
                setDepartamentos(res.data.departamentos);
            }).catch(err => '')
    }, [messageSuccess])

    function HandleChange(e) {
        setDepartamento({ ...departamento, [e.target.name]: e.target.value })
    }

    async function createAdmin() {

        setLoad(true)
        setErrorMessage('')
        setMessageSuccess('')

        await api.post('/departamento/create', { ...departamento, userId: user?._id })
            .then(res => {
                // console.log(res)
                setLoad(false)
                setMessageSuccess(res.data.msg)

            }).catch(error => {
                // console.log(error)
                setErrorMessage(error.response.data.message)
                setLoad(false)
            })
    }

    return (
        <Container>
            <Card style={{ padding: 20, marginBottom: 20 }}>

                {messageSuccess && <MessageSuccess message={messageSuccess} />}
                {messageError && < MessageError message={messageError} />}

                {departamentos ?
                    <div style={{ marginBottom: 50 }}>
                        <HeaderGestorConfigs title='DEPARTAMENTOS:' />
                        {departamentos.map((departamento) => (
                            <Typography key={departamento._id}>
                                <b> {departamento.sigla} :</b> {departamento.designacao}
                            </Typography>
                        ))}
                    </div>
                    :
                    <Loading text={'A carregar Departamentos'} />
                }

                <Grid container className={classes.root}>

                    <Grid Grid xs={12} md item className={classes.gridItem}>
                        <TextField
                            style={{ marginTop: 15 }}
                            type="text"
                            required
                            label="Designação"
                            fullWidth
                            size="small"
                            name="designacao"
                            variant="outlined"
                            onChange={HandleChange}
                            defaultValue={departamento?.designacao}
                        />
                    </Grid>

                    <Grid xs={12} md item className={classes.gridItem}>
                        <TextField
                            style={{ marginTop: 15 }}
                            type="text"
                            required
                            label="Sigla"
                            fullWidth
                            size="small"
                            name="sigla"
                            variant="outlined"
                            onChange={HandleChange}
                            defaultValue={departamento?.Sigla}
                        />
                    </Grid>


                    <Grid xs={12} md item className={classes.gridItem}>

                        <FormControlLabel label={'Tem secções'} value={!departamento?.secoes} name='secoes' control={<Checkbox checked={!!departamento?.secoes} />} onChange={() => setDepartamento({ ...departamento, secoes: !departamento?.secoes })} />

                    </Grid>
                </Grid>

                <ButtonLeft
                    title={'Criar'}
                    load={load}
                    disabled={!departamento?.designacao}
                    funcao={createAdmin}
                />

            </Card>
        </Container>
    )
}
